module.exports = __webpack_public_path__ + "static/media/adrian_mironescu.75c10e8c.png";